<template>
    <div>
        <div class="flex flex-wrap my-3">
            <div class="w-full lg:w-10/12 text-center">
                <h1 class="text-3xl text-center">
                    Colaboradores en
                    {{ selectedMerchant.merchantType | merchantInfo("type") }}
                    <strong class="text-theme-primary">
                        {{ selectedMerchant.name }}
                    </strong>
                </h1>
            </div>
            <div class="w-full lg:w-2/12 flex items-center justify-center">
                <app-button
                    icon
                    circle
                    color="brand-purple"
                    @click="listMerchantsUserComponent"
                >
                    <reload-icon class="h-5 w-5 text-white" />
                </app-button>
            </div>
        </div>

        <div>
            <span>
                En esta sección, podrás visualizar la lista de colaboradores que
                tienen acceso a tu tienda. Si necesitas agregar más personas
                para que realicen operaciones en él, puedes invitarlas desde
                aquí mismo.
            </span>
        </div>

        <div v-if="isLoading" class="flex justify-center">
            <span class="my-3"> Cargando... </span>
        </div>

        <div v-else>
            <users-roles-manage
                v-model="users"
                :enabled="$ability.hasPermission('user:UpdateOwn')"
                :default-filters="{ type: 'merchant' }"
            />
            <div class="flex flex-wrap mt-4">
                <div
                    v-if="$ability.hasPermission('user:UpdateOwn')"
                    class="w-full flex justify-center"
                >
                    <app-button @click="updateUsersMerchantComponent">
                        Actualizar colaboradores
                    </app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import ReloadIcon from "@/components/icons/ReloadIcon.vue";
import UsersRolesManage from "@/components/users/UsersRolesManage.vue";

export default {
    name: "UsersDetails",
    components: {
        UsersRolesManage,
        ReloadIcon
    },
    data: () => ({
        users: [],
        isLoading: false
    }),
    computed: {
        ...mapState("commons", ["selectedMerchant"]),
        ...mapGetters("control", ["backgroundColor"])
    },
    watch: {
        selectedMerchant() {
            this.listMerchantsUserComponent();
        }
    },
    async mounted() {
        const verifyPagePermission =
            this.$ability.verifyPagePermission.bind(this);
        if (!(await verifyPagePermission("user:ListOwn", "/app", true))) return;
        this.listMerchantsUserComponent();
    },
    methods: {
        ...mapActions("users", ["listUsersMerchant", "updateUsersMerchant"]),
        async listMerchantsUserComponent() {
            this.isLoading = true;
            this.$loading.show();
            try {
                this.users = await this.listUsersMerchant({
                    merchantId: this.selectedMerchant.merchantId,
                    merchantType: this.selectedMerchant.merchantType
                });
                this.isLoading = false;
                this.$loading.hide();
            } catch (error) {
                this.isLoading = false;
                this.$loading.hide();
                this.isLoading = false;
                this.$loading.hide();
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        async updateUsersMerchantComponent() {
            this.isLoading = true;
            this.$loading.show();
            try {
                await this.updateUsersMerchant({
                    merchantId: this.selectedMerchant.merchantId,
                    merchantType: this.selectedMerchant.merchantType,
                    users: this.users.map((item) => ({
                        email: item.email,
                        roleSlug: item.role.slug
                    }))
                });
                this.$sound.play();
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Actualización exitosa",
                    icon: "success",
                    showCloseButton: true,
                    timer: 3000
                });
                this.$loading.hide();
                this.isLoading = false;
            } catch (error) {
                this.$loading.hide();
                this.isLoading = false;
                this.$loading.hide();
                this.$sound.play("error");
                this.isLoading = false;
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        }
    }
};
</script>
